import axios from "axios";
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError,
} from "./asyncActions";
import {  REMOVE_VISITOR, LOGOUT, START_FORM, USER_DATA, ADD_VISITOR, FAILED,
     ASYNC_ACTION_START,ASYNC_ACTION_FINISH,ASYNC_ACTION_ERROR,
    UPDATE_VISITOR,CHECK_EMERGENCY_START,CHECK_EMERGENCY_SUCCESS,CHECK_EMERGENCY_FAIL } from "./types";
import { API_URL } from "./api";
import { open } from "./modalActions";
// ★ ה-`t` שברמת-המודול (ולא ההוק) — הקוד כאן אינו רכיב React.
import { t } from "../../i18n";
import { createAsyncThunk } from '@reduxjs/toolkit';

/* ★★ מטמון קצר-טווח לתצורת-האתר.
   ⚠️ נמדד 05/08 בטעינה אחת בטלפון: **12 קריאות זהות** ל-`site-config`.
      הסיבה: כמה רכיבים עצמאיים צריכים אותה (הדר, טופס-ההזמנה, שלב-1,
      מסך-הכניסה), וכל אחד קורא בעצמו — וזה נכון ארכיטקטונית, אבל אין סיבה
      שכל אחד ישלם על בקשת-רשת נפרדת. ברשת סלולרית איטית זה 12 סבבים.
   ★ המטמון הוא על ה-**Promise** ולא על התוצאה, ולכן גם קוראים שמתחילים
     בו-זמנית (וזה בדיוק המקרה כאן) מתאחדים לבקשה אחת.
   ★ TTL קצר: התצורה משתנה רק כשמנהל שומר הגדרות, ורענון-דף מנקה ממילא. */
let __cfgPromise = null;
let __cfgAt = 0;
const CFG_TTL_MS = 30000;

export const fetchSiteConfig = () => async () => {
  const now = Date.now();
  if (__cfgPromise && now - __cfgAt < CFG_TTL_MS) { return __cfgPromise; }
  __cfgAt = now;
  __cfgPromise = axios
    .get(`${API_URL}user/site-config`)
    .then((res) => res.data?.data || res.data || {})
    .catch(() => {
      /* כישלון לא נשמר במטמון — אחרת תקלת-רשת חולפת הייתה משביתה את
         התצורה ל-30 שניות שלמות. */
      __cfgPromise = null;
      return {};
    });
  return __cfgPromise;
};

/* ══════════════════════════════════════════════════════════════════════════
   בדיקת-תקינות של הבחירה הנוכחית בין שלבי טופס-ההזמנה.

   ⚠️⚠️ **הבאג שזה סוגר** (דיווח-משתמש 06/08/2026): רשימת המחלקות מגיעה
      מ-`user/me` ויושבת ב-redux מאז עליית-האפליקציה. מנהל שסגר מחלקה בזמן
      שאזרח כבר היה **בתוך** הטופס — האזרח המשיך לשלב הבא כרגיל, והרשימה
      התרעננה רק אחרי F5.

   ★ **קלה בכוונה.** החלופה — לרענן `user/me` בכל מעבר-שלב — הייתה מושכת גם
     את כל התורים, הדירוגים וטוקני-ה-QR, חמש פעמים בכל הזמנה. כאן שתי
     שאילתות לפי מפתח ראשי ותשובה של שלושה שדות.

   ★★ **fail-open.** תקלת-רשת, 401 שנתפס ע"י interceptor או גוף-תשובה לא-צפוי
      פירושם "אין מידע" — ולא "חסום". חוסמים **אך ורק** כששרת אמר `ok:false`
      במפורש. אותו עיקרון בדיוק כמו `takeHold` של C1, ומאותה סיבה: זו שכבת-
      נוחות, והנכונות נאכפת בשרת ברגע האישור (`CreateAction`).
   ══════════════════════════════════════════════════════════════════════════ */
export const checkSelection = async (departmentId, scheduleId) => {
  try {
    const params = { department_id: departmentId };
    if (scheduleId) { params.schedule_id = scheduleId; }
    const res = await axios.get(`${API_URL}visitors/check-selection`, { params });
    // ⚠️ ה-API עוטף כל תשובה ב-`data` — אותה מלכודת שהפילה את הגרסה
    //    הראשונה של `takeHold` (כל השעות נראו תפוסות).
    const d = (res?.data?.data ?? res?.data) || {};
    if (d.ok === false) {
      return { ok: false, reason: d.reason || '', message: d.message || '' };
    }
    return { ok: true };
  } catch (e) {
    return { ok: true };
  }
};

export const checkEmergency = () => async dispatch => {
  dispatch({ type: ASYNC_ACTION_START })
  dispatch({ type: CHECK_EMERGENCY_START })
  try {
    const res = await axios.get(`${API_URL}user/emergency`)
    const payload = res.data?.data || res.data || {}
    const { emergence_mode, emergency_text } = payload
    dispatch({ type: ASYNC_ACTION_FINISH })
    dispatch({
      type: CHECK_EMERGENCY_SUCCESS,
      payload: {
        mode: emergence_mode === 1,
        text: emergency_text || ""
      }
    })
  } catch (err) {
    dispatch({ type: ASYNC_ACTION_ERROR, payload: err.message })
    dispatch({ type: CHECK_EMERGENCY_FAIL, payload: err.message })
  }
}

export const getHomeData = (docNum) => async (dispatch) => {
  dispatch(asyncActionStart());
  try {
    const url = `${API_URL}user/me`;

    const res = await axios.get(url, { docNum: docNum });

    if (res.error) {
     
      dispatch(asyncActionError(res.error));
    } else {
      dispatch({
        type: USER_DATA,
        payload: res.data.data,
      });

      dispatch(asyncActionFinish());
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch({
        type: LOGOUT,
      });
      dispatch(asyncActionError(t("content.reLogin")));
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      dispatch(asyncActionError(error.response.data.message));
    } else {
      dispatch(asyncActionError("Server error"));
    }
  }
};



export const sendAppointment = (formData) => async dispatch => {
  dispatch(asyncActionStart())
  try {   
    const res = await axios.post(`${API_URL}visitors`, formData)
    if(res.data.data.error) {
         dispatch({
          type: FAILED,
          payload: res.data.data
        });
        dispatch(asyncActionError(res.data.data.error))
    } else {
        dispatch({
          type: ADD_VISITOR,
          payload: res.data.data
        })
        dispatch(open('snack_bar'))
        dispatch(asyncActionFinish())
    }
   
  } catch (error) {
    if (error.response && error.response.data && error.response.data.title) {
      // dispatch(asyncActionError(error.response.data.title))
      dispatch(asyncActionError(error.response.data))
    } else {     
        dispatch(asyncActionError('Server error'))    
    }
  }
}



export const deleteAppointment = (id) => async dispatch => {
  dispatch(asyncActionStart())
  try {   
    // Sent as POST + method-override (not a real DELETE): IIS/WebDAV on the hosted sites blocks the
    // DELETE verb with a 405 before it reaches PHP. Yii maps X-Http-Method-Override back to DELETE.
    const res = await axios.post(`${API_URL}visitors/${id}`, {}, {
      headers: { 'X-Http-Method-Override': 'DELETE' },
    })
   
    if(res.status == 204) {
     
        dispatch({
          type: REMOVE_VISITOR,
          payload: id
        })
        dispatch(open('snack_bar'))
        dispatch(asyncActionFinish())
    }
   
  } catch (error) {    
    if (error.response && error.response.data && error.response.data.title) {
      // dispatch(asyncActionError(error.response.data.title))
      dispatch(asyncActionError(error.response.data))
    } else {     
        dispatch(asyncActionError('Server error'))    
    }
  }
};


export const updateAppointment = createAsyncThunk(
  'appointments/update',
  async ({ id, formData }, { rejectWithValue }) => {
      

    try {
      // POST + method-override instead of a real PUT: IIS/WebDAV blocks PUT with a 405 before PHP.
      // Yii maps the X-Http-Method-Override header back to PUT → routes to the update action.
      const res = await axios.post(`${API_URL}visitors/${id}`, formData, {
        headers: { 'X-Http-Method-Override': 'PUT' },
      });
      
      // Check if the response contains an error message
      if (res.data.data && res.data.data.error) {
        return rejectWithValue(res.data.data.error);
      }
      
      if (res.status === 200) {
        return res.data.data;
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.title) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue('Server error');
    }
  }
);



// C8 — submit a service rating (1-5 + optional comment) for a PAST appointment. Returns the API result.
// The auth token is attached by the axios interceptor (setAuthToken).
export const submitRating = (visitorId, rating, comment) => async () => {
  const res = await axios.post(`${API_URL}visitors/rate`, {
    visitor_id: visitorId,
    rating,
    comment: comment || '',
  });
  return res.data;
};

export const startForm = (row) => {
  return {
    type: START_FORM,
  };
};





